/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartShippingTooltip_item$ref = any;
export type CartNoShipping_item$ref = any;
export type CartNoShipping_item = {
    readonly " $fragmentRefs": CartShippingTooltip_item$ref;
    readonly " $refType": CartNoShipping_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartNoShipping_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartShippingTooltip_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '62c32da5b378d99775f6e6d4d8dad429';
export default node;
